import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attendances-view',
  templateUrl: './attendances-view.component.html',
  styleUrls: ['./attendances-view.component.css']
})
export class AttendancesViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
